import { useState, useEffect } from 'react';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookies_accepted', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-4 pb-4 md:px-8 md:pb-6 animate-fade-in-up">
      <div className="max-w-4xl mx-auto bg-[#0d0d0d] border border-yellow-700/30 rounded-xl px-5 py-4 md:px-7 md:py-5 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-2xl">
        {/* Icon */}
        <div className="w-9 h-9 flex items-center justify-center shrink-0 rounded-full bg-yellow-900/20 border border-yellow-700/30">
          <i className="ri-shield-check-line text-yellow-500 text-base"></i>
        </div>

        {/* Text */}
        <p className="text-white/50 text-xs leading-relaxed flex-1">
          We use cookies to improve your experience on our site. By continuing to browse, you agree to our use of cookies.{' '}
          <a
            href="https://www.privacypolicygenerator.info/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-yellow-600/80 hover:text-yellow-400 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
          >
            Learn more
          </a>
        </p>

        {/* Buttons */}
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleDecline}
            className="whitespace-nowrap px-4 py-2 text-xs tracking-widest uppercase text-white/30 hover:text-white/60 transition-colors duration-200 cursor-pointer"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="whitespace-nowrap px-5 py-2 text-xs tracking-widest uppercase text-yellow-300 bg-gradient-to-r from-purple-800 to-black border border-yellow-600/40 rounded-full hover:border-yellow-500 hover:from-purple-700 transition-all duration-300 cursor-pointer"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
